/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCommentByProgramId = /* GraphQL */ `
  subscription OnCreateCommentByProgramId($programId: ID!) {
    onCreateCommentByProgramId(programId: $programId) {
      id
      dataType
      userId
      userName
      comment
      commentDateTime
      programId
      status
      updateStatusDateTime
      isRehearsal
      isSticky
      createdAt
      updatedAt
    }
  }
`;
export const onModifyCommentByProgramId = /* GraphQL */ `
  subscription OnModifyCommentByProgramId($programId: ID!) {
    onModifyCommentByProgramId(programId: $programId) {
      id
      dataType
      userId
      userName
      comment
      commentDateTime
      programId
      status
      updateStatusDateTime
      isRehearsal
      isSticky
      createdAt
      updatedAt
    }
  }
`;
export const onModifyProgramByDatatype = /* GraphQL */ `
  subscription OnModifyProgramByDatatype($id: ID!, $dataType: String!) {
    onModifyProgramByDatatype(id: $id, dataType: $dataType) {
      id
      dataType
      programName
      programDescription
      livestreamStartDateTime
      livestreamEndDateTime
      livestreamStatus
      thumbnailUrl
      ngWord
      cameraSetting
      livestreamSns
      livestreamType
      template
      cartInDatetime
      reactionDatetime
      audienceCount
      productCode
      productStatusUpdateAt
      userId
      customerId
      shopUrl
      livestreamPlaybackUrl
      cartInTotal
      commentTotal
      goExternalSiteTotal
      audienceAverage
      shopType
      livestreamDownloadUrls
      isDeleted
      theme
      disableScrollComment
      goProductDetailDatetime
      storagedManage
      storagedStatus
      isRehearsal
      hasCheckout
      isFeatured
      clientIdBShop
      clientSecretBShop
      callbackUrlBShop
      accessTokenBShop
      refreshTokenBShop
      tokenCreationTimeBShop
      uploadVideoUrl
      archivedVideoPlayTime
      lineChannelId
      lineAddFriendBtnHtml
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      product {
        id
        productName
        productImageUrl
        productPrice
        productSalePrice
        productDescription
        productUrl
        productSize
        productColor
        quantity
        remainQuantity
        minQuantity
        brandName
        shopType
        customerId
        isDeleted
        productImageUrls
        createdAt
        updatedAt
        customer {
          items {
            id
            dataType
            companyName
            companyNameKana
            contractStatus
            contractDate
            customerPicName
            customerPicNameKana
            lbPicName
            lbPicNameKana
            memo
            ngWord
            livestreamSns
            userToken
            snsChannelName
            snsChannelId
            snsChannelToken
            snsBroadcastId
            snsStreamId
            ga
            logoUrl
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer {
    onCreateCustomer {
      id
      dataType
      companyName
      companyNameKana
      contractStatus
      contractDate
      customerPicName
      customerPicNameKana
      lbPicName
      lbPicNameKana
      memo
      ngWord
      livestreamSns
      userToken
      snsChannelName
      snsChannelId
      snsChannelToken
      snsBroadcastId
      snsStreamId
      ga
      logoUrl
      isDeleted
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer {
    onUpdateCustomer {
      id
      dataType
      companyName
      companyNameKana
      contractStatus
      contractDate
      customerPicName
      customerPicNameKana
      lbPicName
      lbPicNameKana
      memo
      ngWord
      livestreamSns
      userToken
      snsChannelName
      snsChannelId
      snsChannelToken
      snsBroadcastId
      snsStreamId
      ga
      logoUrl
      isDeleted
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer {
    onDeleteCustomer {
      id
      dataType
      companyName
      companyNameKana
      contractStatus
      contractDate
      customerPicName
      customerPicNameKana
      lbPicName
      lbPicNameKana
      memo
      ngWord
      livestreamSns
      userToken
      snsChannelName
      snsChannelId
      snsChannelToken
      snsBroadcastId
      snsStreamId
      ga
      logoUrl
      isDeleted
      createdAt
      updatedAt
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      id
      userName
      userNameKana
      companyId
      role
      createdAt
      updatedAt
      company {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      id
      userName
      userNameKana
      companyId
      role
      createdAt
      updatedAt
      company {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser {
    onDeleteUser {
      id
      userName
      userNameKana
      companyId
      role
      createdAt
      updatedAt
      company {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateProgram = /* GraphQL */ `
  subscription OnCreateProgram {
    onCreateProgram {
      id
      dataType
      programName
      programDescription
      livestreamStartDateTime
      livestreamEndDateTime
      livestreamStatus
      thumbnailUrl
      ngWord
      cameraSetting
      livestreamSns
      livestreamType
      template
      cartInDatetime
      reactionDatetime
      audienceCount
      productCode
      productStatusUpdateAt
      userId
      customerId
      shopUrl
      livestreamPlaybackUrl
      cartInTotal
      commentTotal
      goExternalSiteTotal
      audienceAverage
      shopType
      livestreamDownloadUrls
      isDeleted
      theme
      disableScrollComment
      goProductDetailDatetime
      storagedManage
      storagedStatus
      isRehearsal
      hasCheckout
      isFeatured
      clientIdBShop
      clientSecretBShop
      callbackUrlBShop
      accessTokenBShop
      refreshTokenBShop
      tokenCreationTimeBShop
      uploadVideoUrl
      archivedVideoPlayTime
      lineChannelId
      lineAddFriendBtnHtml
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      product {
        id
        productName
        productImageUrl
        productPrice
        productSalePrice
        productDescription
        productUrl
        productSize
        productColor
        quantity
        remainQuantity
        minQuantity
        brandName
        shopType
        customerId
        isDeleted
        productImageUrls
        createdAt
        updatedAt
        customer {
          items {
            id
            dataType
            companyName
            companyNameKana
            contractStatus
            contractDate
            customerPicName
            customerPicNameKana
            lbPicName
            lbPicNameKana
            memo
            ngWord
            livestreamSns
            userToken
            snsChannelName
            snsChannelId
            snsChannelToken
            snsBroadcastId
            snsStreamId
            ga
            logoUrl
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateProgram = /* GraphQL */ `
  subscription OnUpdateProgram {
    onUpdateProgram {
      id
      dataType
      programName
      programDescription
      livestreamStartDateTime
      livestreamEndDateTime
      livestreamStatus
      thumbnailUrl
      ngWord
      cameraSetting
      livestreamSns
      livestreamType
      template
      cartInDatetime
      reactionDatetime
      audienceCount
      productCode
      productStatusUpdateAt
      userId
      customerId
      shopUrl
      livestreamPlaybackUrl
      cartInTotal
      commentTotal
      goExternalSiteTotal
      audienceAverage
      shopType
      livestreamDownloadUrls
      isDeleted
      theme
      disableScrollComment
      goProductDetailDatetime
      storagedManage
      storagedStatus
      isRehearsal
      hasCheckout
      isFeatured
      clientIdBShop
      clientSecretBShop
      callbackUrlBShop
      accessTokenBShop
      refreshTokenBShop
      tokenCreationTimeBShop
      uploadVideoUrl
      archivedVideoPlayTime
      lineChannelId
      lineAddFriendBtnHtml
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      product {
        id
        productName
        productImageUrl
        productPrice
        productSalePrice
        productDescription
        productUrl
        productSize
        productColor
        quantity
        remainQuantity
        minQuantity
        brandName
        shopType
        customerId
        isDeleted
        productImageUrls
        createdAt
        updatedAt
        customer {
          items {
            id
            dataType
            companyName
            companyNameKana
            contractStatus
            contractDate
            customerPicName
            customerPicNameKana
            lbPicName
            lbPicNameKana
            memo
            ngWord
            livestreamSns
            userToken
            snsChannelName
            snsChannelId
            snsChannelToken
            snsBroadcastId
            snsStreamId
            ga
            logoUrl
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteProgram = /* GraphQL */ `
  subscription OnDeleteProgram {
    onDeleteProgram {
      id
      dataType
      programName
      programDescription
      livestreamStartDateTime
      livestreamEndDateTime
      livestreamStatus
      thumbnailUrl
      ngWord
      cameraSetting
      livestreamSns
      livestreamType
      template
      cartInDatetime
      reactionDatetime
      audienceCount
      productCode
      productStatusUpdateAt
      userId
      customerId
      shopUrl
      livestreamPlaybackUrl
      cartInTotal
      commentTotal
      goExternalSiteTotal
      audienceAverage
      shopType
      livestreamDownloadUrls
      isDeleted
      theme
      disableScrollComment
      goProductDetailDatetime
      storagedManage
      storagedStatus
      isRehearsal
      hasCheckout
      isFeatured
      clientIdBShop
      clientSecretBShop
      callbackUrlBShop
      accessTokenBShop
      refreshTokenBShop
      tokenCreationTimeBShop
      uploadVideoUrl
      archivedVideoPlayTime
      lineChannelId
      lineAddFriendBtnHtml
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      product {
        id
        productName
        productImageUrl
        productPrice
        productSalePrice
        productDescription
        productUrl
        productSize
        productColor
        quantity
        remainQuantity
        minQuantity
        brandName
        shopType
        customerId
        isDeleted
        productImageUrls
        createdAt
        updatedAt
        customer {
          items {
            id
            dataType
            companyName
            companyNameKana
            contractStatus
            contractDate
            customerPicName
            customerPicNameKana
            lbPicName
            lbPicNameKana
            memo
            ngWord
            livestreamSns
            userToken
            snsChannelName
            snsChannelId
            snsChannelToken
            snsBroadcastId
            snsStreamId
            ga
            logoUrl
            isDeleted
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      productName
      productImageUrl
      productPrice
      productSalePrice
      productDescription
      productUrl
      productSize
      productColor
      quantity
      remainQuantity
      minQuantity
      brandName
      shopType
      customerId
      isDeleted
      productImageUrls
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      productName
      productImageUrl
      productPrice
      productSalePrice
      productDescription
      productUrl
      productSize
      productColor
      quantity
      remainQuantity
      minQuantity
      brandName
      shopType
      customerId
      isDeleted
      productImageUrls
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      productName
      productImageUrl
      productPrice
      productSalePrice
      productDescription
      productUrl
      productSize
      productColor
      quantity
      remainQuantity
      minQuantity
      brandName
      shopType
      customerId
      isDeleted
      productImageUrls
      createdAt
      updatedAt
      customer {
        items {
          id
          dataType
          companyName
          companyNameKana
          contractStatus
          contractDate
          customerPicName
          customerPicNameKana
          lbPicName
          lbPicNameKana
          memo
          ngWord
          livestreamSns
          userToken
          snsChannelName
          snsChannelId
          snsChannelToken
          snsBroadcastId
          snsStreamId
          ga
          logoUrl
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment {
    onCreateComment {
      id
      dataType
      userId
      userName
      comment
      commentDateTime
      programId
      status
      updateStatusDateTime
      isRehearsal
      isSticky
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment {
    onUpdateComment {
      id
      dataType
      userId
      userName
      comment
      commentDateTime
      programId
      status
      updateStatusDateTime
      isRehearsal
      isSticky
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment {
    onDeleteComment {
      id
      dataType
      userId
      userName
      comment
      commentDateTime
      programId
      status
      updateStatusDateTime
      isRehearsal
      isSticky
      createdAt
      updatedAt
    }
  }
`;
